import { createAction } from '../../../../store.model';
import { Category, Item } from '../../core';
import { ActionType } from '../event-centre-dialog.action';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface Reload {}

export const reload = createAction<ActionType, Reload>(
    ActionType.NOTI__EC__RELOAD,
);

export interface ReloadResult extends Reload {
    categories?: Category[];
    items?: Item[];
}

export const reloadResult = createAction<ActionType, ReloadResult>(
    ActionType.NOTI__EC__RELOAD_RESULT,
);
